import { getEarnedFeesAndVolumeForPools } from '@/shared/graphql/lp/boost';
import { useAllBoostPools } from '@/shared/hooks/useAllBoostPools';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

export default function useAllBoostPoolsInfo() {
  const { totalBoostLiquidityUsd, isLoading: isTotalBoostLiquidityLoading } = useAllBoostPools();

  const { data: volumeAndFeeData, isLoading: isFeesAndVolumeLoading } = useGqlQuery(
    getEarnedFeesAndVolumeForPools,
    {
      context: { clientName: 'lpProcessor' },
      refetchInterval: 30_000,
    },
  );

  const { totalBoostVolumeUsd, totalBoostFeeUsd } = (volumeAndFeeData?.pools?.nodes ?? []).reduce(
    (acc, pool) => ({
      totalBoostVolumeUsd:
        acc.totalBoostVolumeUsd + Number(pool.shares.aggregates?.sum?.amountUsd ?? 0),
      totalBoostFeeUsd: acc.totalBoostFeeUsd + Number(pool.shares.aggregates?.sum?.feeUsd ?? 0),
    }),
    { totalBoostVolumeUsd: 0, totalBoostFeeUsd: 0 },
  );

  return {
    totalBoostLiquidityUsd: isTotalBoostLiquidityLoading ? null : totalBoostLiquidityUsd,
    totalBoostVolumeUsd: isFeesAndVolumeLoading ? null : totalBoostVolumeUsd,
    totalBoostFeeUsd: isFeesAndVolumeLoading ? null : totalBoostFeeUsd,
  };
}
